import { useCallback, useEffect } from 'react';
import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { useOptionsProvider } from '@frontend/call-intel-core';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';

const DEFAULT_TASK_STATUS: TaskStatus[] = [];

export const useTaskStatusFilterData = () => {
  const { filterValues, updateFilterValues, updateFilterModified, isLoading } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();

  useEffect(() => {
    updateFilterModified({ taskStatus: !!filterValues.taskStatus?.length });
  }, [filterValues.taskStatus, updateFilterModified]);

  const onChange = useCallback(
    (value: TaskStatus[]) => {
      updateFilterValues({ taskStatus: value });
    },
    [updateFilterValues]
  );

  return {
    taskStatusOptions: getOptions('taskStatus'),
    value: filterValues.taskStatus || [],
    defaultValue: DEFAULT_TASK_STATUS,
    isLoading,
    onChange,
  };
};
